import { css, etiColors } from '@eti/styles';
import { Icon as EtiIcon } from '@eti/components';
import { visaTypes } from '../utils/constants';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const wrapperStyles = css`
  align-items: center;
  display: flex;

  p {
    font-size: 0.85rem;
    padding: 0 8px;
  }
`;
const iconStyles = css`
  min-width: 14px;
`;
export const getIconColor = type => {
  switch (type) {
    case visaTypes.VISA_NOT_NEEDED:
      return etiColors.grayScale[9];
    case visaTypes.VISA_UNKNOWN:
    case visaTypes.VISA_NOT_AVAILABLE:
      return etiColors.warning.solid;
    case visaTypes.VISA_TRANSIT:
    case visaTypes.VISA_TOURISM:
    default:
      return etiColors.confirmation.solid;
  }
};
const SimpleVisaTypeDescription = ({
  text,
  type
}) => /*#__PURE__*/_jsxs("div", {
  className: wrapperStyles,
  children: [/*#__PURE__*/_jsx(EtiIcon, {
    className: iconStyles,
    color: getIconColor(type),
    id: "simple-visa",
    size: "14px"
  }), /*#__PURE__*/_jsx("p", {
    children: text
  })]
});
export default SimpleVisaTypeDescription;
//# sourceMappingURL=SimpleVisaTypeDescription.js.map